<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 490.667 490.667"
    style="enable-background:new 0 0 490.667 490.667;"
    xml:space="preserve"
  >
    <path
      :fill="shape"
      d="M245.333,0C110.059,0,0,110.059,0,245.333s110.059,245.333,245.333,245.333s245.333-110.059,245.333-245.333
		S380.608,0,245.333,0z M245.333,469.333c-123.52,0-224-100.48-224-224s100.48-224,224-224s224,100.48,224,224
		S368.853,469.333,245.333,469.333z"
    />
    <path
      :fill="shape"
      d="M245.333,234.667c-76.459,0-138.667,62.208-138.667,138.667c0,5.888,4.779,10.667,10.667,10.667S128,379.221,128,373.333
		C128,308.629,180.629,256,245.333,256s117.333,52.629,117.333,117.333c0,5.888,4.779,10.667,10.667,10.667
		c5.888,0,10.667-4.779,10.667-10.667C384,296.875,321.792,234.667,245.333,234.667z"
    />
    <path
      :fill="shape"
      d="M245.333,64c-41.173,0-74.667,33.493-74.667,74.667s33.493,74.667,74.667,74.667S320,179.84,320,138.667
		S286.507,64,245.333,64z M245.333,192C215.936,192,192,168.064,192,138.667s23.936-53.333,53.333-53.333
		s53.333,23.936,53.333,53.333S274.731,192,245.333,192z"
    />
  </svg>
  <!-- <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 50 50" enable-background="new 0 0 50 50" xml:space="preserve">
		<circle :fill="bg" cx="25" cy="25" r="25"/>
		<path :fill="shape" d="M24.86,26.5c0.04,0,0.08,0,0.128,0c0.016,0,0.032,0,0.048,0c0.024,0,0.056,0,0.08,0c2.344-0.041,4.241-0.864,5.641-2.44c3.081-3.473,2.568-9.425,2.512-9.993c-0.2-4.265-2.216-6.305-3.88-7.257c-1.24-0.712-2.688-1.096-4.304-1.128h-0.056c-0.008,0-0.024,0-0.032,0h-0.048c-0.888,0-2.632,0.144-4.304,1.096c-1.681,0.952-3.729,2.992-3.929,7.289c-0.056,0.568-0.568,6.521,2.512,9.993C20.619,25.636,22.516,26.46,24.86,26.5zM18.851,14.267c0-0.024,0.008-0.048,0.008-0.064c0.264-5.736,4.336-6.353,6.08-6.353h0.032c0.016,0,0.04,0,0.064,0c2.161,0.048,5.833,0.928,6.081,6.353c0,0.024,0,0.048,0.008,0.064c0.008,0.056,0.568,5.497-1.976,8.36c-1.008,1.136-2.353,1.696-4.121,1.712c-0.016,0-0.024,0-0.04,0l0,0c-0.016,0-0.024,0-0.04,0c-1.76-0.016-3.112-0.576-4.112-1.712C18.299,19.779,18.843,14.315,18.851,14.267z"/>
		<path :fill="shape" d="M41.43,36.374c0-0.008,0-0.016,0-0.024c0-0.064-0.008-0.128-0.008-0.2c-0.048-1.584-0.152-5.289-3.625-6.473c-0.024-0.007-0.056-0.016-0.08-0.024c-3.608-0.92-6.609-3-6.641-3.024c-0.488-0.344-1.16-0.224-1.504,0.265c-0.344,0.488-0.224,1.16,0.264,1.503c0.136,0.096,3.32,2.313,7.305,3.337c1.864,0.664,2.072,2.656,2.128,4.48c0,0.072,0,0.137,0.008,0.201c0.008,0.72-0.04,1.832-0.168,2.472c-1.296,0.736-6.377,3.28-14.105,3.28c-7.697,0-12.809-2.552-14.114-3.289c-0.128-0.64-0.185-1.752-0.168-2.472c0-0.064,0.008-0.128,0.008-0.2c0.056-1.825,0.264-3.817,2.128-4.481c3.984-1.024,7.169-3.248,7.305-3.336c0.488-0.344,0.608-1.016,0.264-1.504s-1.016-0.608-1.504-0.264c-0.032,0.024-3.017,2.104-6.641,3.024c-0.032,0.008-0.056,0.016-0.081,0.024c-3.472,1.191-3.576,4.896-3.624,6.472c0,0.072,0,0.136-0.008,0.2c0,0.008,0,0.016,0,0.024c-0.008,0.416-0.016,2.552,0.408,3.625c0.08,0.208,0.224,0.384,0.416,0.504c0.24,0.16,5.993,3.825,15.618,3.825c9.625,0,15.378-3.672,15.618-3.825c0.184-0.12,0.336-0.296,0.416-0.504C41.446,38.925,41.438,36.79,41.43,36.374z"/>
	</svg> -->
</template>

<script>
export default {
  name: 'PassengerIcon',
  props: {
    bg: { type: String, default () { return '#33A0AF' } },
    shape: { type: String, default () { return '#757575' } }
  }
}
</script>
